module.exports = __webpack_public_path__ + "img/icon_tt_arr_up.15430cad.svg";